export function ScalarValue({ v }: { v: unknown }) {
  if (v === null || v === undefined)
    return <span style={{ color: 'var(--fg-3)', fontStyle: 'italic' }}>null</span>
  if (typeof v === 'boolean')
    return <span style={{ fontSize: 11, padding: '1px 7px', borderRadius: 4, background: v ? 'rgba(184,255,58,0.12)' : 'rgba(255,80,80,0.1)', color: v ? '#B8FF3A' : '#ff7070' }}>{String(v)}</span>
  const s = String(v)
  if (/^https?:\/\//i.test(s))
    return <a href={s} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)', wordBreak: 'break-all' }}>{s}</a>
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s))
    return <a href={`mailto:${s}`} style={{ color: 'var(--accent)' }}>{s}</a>
  if (typeof v === 'number')
    return <span>{v.toLocaleString()}</span>
  return <span style={{ wordBreak: 'break-all' }}>{s}</span>
}
